<template>
<div class="performance">
  <div class="main-con">
<!--搜索框-->
    <div class="search">
      <el-form class="search_form" ref="form" :model="form">
        <div style="display: flex;flex-wrap: wrap" v-if="!showSelete">
          <el-form-item label="创建时间" class="time_form" style="display: flex">
            <div class="time_input">
              <el-date-picker
                v-model="form.startTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="开始时间"
                style="width: 170px;height: 32px;border: none"
              >
              </el-date-picker>
              &nbsp;-&nbsp;
              <el-date-picker
                v-model="form.endTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="结束时间"
                style="width: 190px"
                @change="end"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="买方名称">
            <el-input placeholder="请输入" @change="getListSelect" v-model="form.customerName"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input placeholder="请输入" @change="getListSelect" v-model="form.projectName"></el-input>
          </el-form-item>
          <el-form-item label="所属省市" prop="province">
            <el-select
              v-model="form.province"
              style="width: 181px"
              placeholder="请选择省区"
              @change="handleProvinceChange"
              clearable
            >
              <el-option
                v-for="item in provinceList"
                :key="item.province"
                :label="item.province"
                :value="item.province"
              >
              </el-option>
            </el-select>
            <el-select style="margin-left: 10px" v-model="form.city" placeholder="请选择市区" clearable>
              <el-option
                v-for="item in cityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input placeholder="请输入" @change="getListSelect" v-model="form.contractNum"></el-input>
          </el-form-item>
          <el-form-item class="business-con" label="业态类型">
            <el-select @change="handleBusinessTypeChange" v-model="form.busTypeId" placeholder="请选择" clearable>
              <el-option v-for = "item in businessTypeList" :key="item.bid" :label ='item.name'
                         :value="item.bid">
              </el-option>
            </el-select>
            <el-select style ="margin-left: 10px" v-model="form.busId" @change = "handleBusinessChange"
                       placeholder="请选择" clearable>
              <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="business-con" label="梯种">
            <el-select v-model="form.elevatorTId" @change="handChange" placeholder="请选择" clearable>
              <el-option v-for = "item in seriesList" :key="item.etId" :label ='item.etName'
                         :value="item.etId">
              </el-option>
            </el-select>
            <el-select style ="margin-left: 10px" v-model="form.elevatorId" placeholder="请选择" clearable>
              <el-option v-for="item in elevatorSeriesList" :key="item.eId" :label="item.enum" :value="item.eId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="form.area" placeholder="请选择" clearable>
              <el-option
                v-for="item in optionsArea"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首次商审结束日期" class="time_form">
          <div class="time_input">
            <el-date-picker
              v-model="form.firstConsultationStartTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="开始时间"
              style="width: 190px;height: 32px;border: none"
            >
            </el-date-picker>
            &nbsp;-&nbsp;
            <el-date-picker
              v-model="form.firstConsultationEndTime"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="结束时间"
              style="width: 190px"
              @change="endHe"
            >
            </el-date-picker>
          </div>
        </el-form-item>
          <div class="JournalismShow" @click="goShow" v-if="!showSelete">更多搜索<i :class="icon"></i></div>
        </div>
        <div style="display: flex;flex-wrap: wrap" v-if="showSelete">
          <el-form-item label="创建时间" class="time_form" style="display: flex">
            <div class="time_input">
              <el-date-picker
                v-model="form.startTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="开始时间"
                style="width: 170px;height: 32px;border: none"
              >
              </el-date-picker>
              &nbsp;-&nbsp;
              <el-date-picker
                v-model="form.endTime"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="结束时间"
                style="width: 190px"
                @change="end"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="买方名称">
            <el-input placeholder="请输入" v-model="form.customerName"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input placeholder="请输入" v-model="form.projectName"></el-input>
          </el-form-item>
          <el-form-item label="所属省市" prop="province">
            <el-select
              v-model="form.province"
              style="width: 181px"
              placeholder="请选择省区"
              @change="handleProvinceChange"
              clearable
            >
              <el-option
                v-for="item in provinceList"
                :key="item.province"
                :label="item.province"
                :value="item.province"
              >
              </el-option>
            </el-select>
            <el-select style="margin-left: 10px" v-model="form.city" placeholder="请选择市区" clearable>
              <el-option
                v-for="item in cityList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="合同编号">
            <el-input placeholder="请输入" v-model="form.contractNum"></el-input>
          </el-form-item>
          <el-form-item class="business-con" label="业态类型">
            <el-select @change="handleBusinessTypeChange" v-model="form.busTypeId" placeholder="请选择" clearable>
              <el-option v-for = "item in businessTypeList" :key="item.bid" :label ='item.name'
                         :value="item.bid">
              </el-option>
            </el-select>
            <el-select style ="margin-left: 10px" v-model="form.busId" @change = "handleBusinessChange"
                       placeholder="请选择" clearable>
              <el-option v-for="item in businessList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="business-con" label="梯种">
            <el-select v-model="form.elevatorTId" @change="handChange" placeholder="请选择" clearable>
              <el-option v-for = "item in seriesList" :key="item.etId" :label ='item.etName'
                         :value="item.etId">
              </el-option>
            </el-select>
            <el-select style ="margin-left: 10px" v-model="form.elevatorId" placeholder="请选择" clearable>
              <el-option v-for="item in elevatorSeriesList" :key="item.eId" :label="item.enum" :value="item.eId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域">
            <el-select v-model="form.area" placeholder="请选择" clearable>
              <el-option
                v-for="item in optionsArea"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="首次商审结束日期" class="time_form">
            <div class="time_input">
              <el-date-picker
                v-model="form.firstConsultationStartTime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
                style="width: 190px;height: 32px;border: none"
              >
              </el-date-picker>
              &nbsp;-&nbsp;
              <el-date-picker
                v-model="form.firstConsultationEndTime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="结束时间"
                style="width: 190px"
                @change="endHe"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="项目验收发证日期" class="time_form">
            <div class="time_input">
              <el-date-picker
                v-model="form.receiveCertificatesStartTime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="开始时间"
                style="width: 190px;height: 32px;border: none"
              >
              </el-date-picker>
              &nbsp;-&nbsp;
              <el-date-picker
                v-model="form.receiveCertificatesEndTime"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="结束时间"
                style="width: 190px"
                @change="endPro"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="直梯台量">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.straightUnitsMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.straightUnitsMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="扶梯台量">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.escalatorsUnitsMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.escalatorsUnitsMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="总台量">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.totalUnitsMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.totalUnitsMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="合同签约总价（万）">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="contractTotalPriceMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="contractTotalPriceMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="设备及运输费用金额（万）">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="deviceSignedPriceMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="deviceSignedPriceMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="工程签约价（万）（含附加工程费）">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="projectSignedPriceMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="projectSignedPriceMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="直梯提升高度（米）">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="straightRaisedHighMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="straightRaisedHighMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="扶梯提升高度（米）">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="escalatorsRaisedHighMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="escalatorsRaisedHighMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="最高速度（米/秒）">
            <div>
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.speedMin" placeholder="（最小）" style="width: 100px"></el-input>
              ~
              <el-input oninput ="value=value.replace(/[^0-9.]/g,'')" v-model="form.speedMax" placeholder="（最大）" style="width: 100px"></el-input>
            </div>
          </el-form-item>
          <el-form-item label="中标通知书">
            <div>
              <el-select v-model="form.projectBidNotice" placeholder="请选择">
                <el-option
                  v-for="item in selectValue"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
<!--              <el-radio-group v-model="form.projectBidNotice">-->
<!--                <el-radio label="true" class="rad" @click.native.prevent="onRadioChange('true')">有</el-radio>-->
<!--                <el-radio label="false" @click.native.prevent="onRadioChange('false')">无</el-radio>-->
<!--              </el-radio-group>-->
            </div>
          </el-form-item>
          <el-form-item label="合同扫描件" style="margin-left: 30px">
            <div>
              <el-select v-model="form.projectContractScaner" placeholder="请选择">
                <el-option
                  v-for="item in selectValue"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
<!--              <el-radio-group v-model="form.projectContractScaner">-->
<!--                <el-radio label="true" class="rad" @click.native.prevent="onRadioChange2('true')">有</el-radio>-->
<!--                <el-radio label="false" @click.native.prevent="onRadioChange2('false')">无</el-radio>-->
<!--              </el-radio-group>-->
            </div>
          </el-form-item>
          <el-form-item label="验收报告" style="margin-left: 30px">
            <div>
              <el-select v-model="form.projectAcceptReport" placeholder="请选择">
                <el-option
                  v-for="item in selectValue"
                  :key="item.id"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
<!--              <el-radio-group v-model="form.projectAcceptReport">-->
<!--                <el-radio label="true" class="rad" @click.native.prevent="onRadioChange3('true')">有</el-radio>-->
<!--                <el-radio label="false" @click.native.prevent="onRadioChange3('false')">无</el-radio>-->
<!--              </el-radio-group>-->
            </div>
          </el-form-item>
        </div>
        <div class="JournalismShow" @click="goShow" v-if="showSelete">收起更多搜索<i :class="icon"></i></div>
        <el-form-item>
          <el-button size="small" style="font-size: 14px" plain type="primary" icon="el-icon-search" @click="getListSelect">查询</el-button>
          <el-button size="small" style="margin-left: 10px;font-size: 14px" plain icon="el-icon-delete" @click="clearForm">清空</el-button>
          <el-button size="small" style="margin-left: 10px;font-size: 14px" plain type="primary" icon="el-icon-document" @click="selectDao">导出清单</el-button>
        </el-form-item>
      </el-form>
    </div>
<!--表格数据-->
    <div class="per_List">
      <div class="text">
        <div class="title">
          全部清单
        </div>
      </div>
      <div class="check">
        <el-checkbox disabled v-model="check"></el-checkbox>
        <div style="margin:0px 10px">已选择{{ num }}条</div>
        |
        <div style="margin-right: 10px">批量操作</div>
        <el-button style="" icon="el-icon-document" @click="getExport">导出选择清单</el-button>
      </div>
      <el-table
        :data="performanceList"
        style="width: 100%"
        ref="table"
        :header-cell-style="{textAlign:'center',background:'#EBE9E9', color:'#000000', fontsize:'16px'}"
        :cell-style="{textAlign:'center', color: 'rgba(0,0,0,0.85)', fontsize:'14px'}"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55"
          fixed="left"
          >
        </el-table-column>
        <el-table-column label="合同编号" prop="contractNum" width="150"></el-table-column>
        <el-table-column label="买方名称" prop="buyerName" width="250"></el-table-column>
        <el-table-column label="使用单位" prop="usedUnits" width="150"></el-table-column>
        <el-table-column label="项目名称" prop="projectName" width="150"></el-table-column>
        <el-table-column label="商机名称" prop="bussinessName" width="200"></el-table-column>
        <el-table-column label="直梯台数" prop="straightNum"></el-table-column>
        <el-table-column label="扶梯台数" prop="escalatorNum"></el-table-column>
        <el-table-column label="总台数" prop="totalNum"></el-table-column>
        <el-table-column label="合同签约总价区间（元）" prop="fuzzyContractTotalPrice" width="150"></el-table-column>
        <el-table-column label="设备及运输签约价区间（元）" prop="fuzzyDeviceSignedPrice" width="150"></el-table-column>
        <el-table-column label="工程签约价区间（元）（含附加工程费）" prop="fuzzyProjectSignedPrice" width="150"></el-table-column>
        <el-table-column label="项目业态" prop="projectFormat"></el-table-column>
        <el-table-column label="首次商审结束日期" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.firstConsultationEndTime">{{ scope.row.firstConsultationEndTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="项目验收发证日期（最早）" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.receiveCertificatesTime">{{ scope.row.receiveCertificatesTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="工程区域" prop="area"></el-table-column>
        <el-table-column label="工程省份" prop="province"></el-table-column>
        <el-table-column label="工程地点" prop="city"></el-table-column>
        <el-table-column label="梯种" prop="elevator" width="250"></el-table-column>
        <el-table-column label="直梯提升高（最大值）（米）" prop="straightRaisedHigh" width="200"></el-table-column>
        <el-table-column label="扶梯提升高（最大值）（米）" prop="escalatorsRaisedHigh" width="200"></el-table-column>
        <el-table-column label="速度（最大值）（米/秒）" prop="speed" width="200"></el-table-column>
        <el-table-column label="≤2.5m/s台数" prop="units1" width="100"></el-table-column>
        <el-table-column label="3～4 m/s台数" prop="units2" width="120"></el-table-column>
        <el-table-column label="5m/s台数" prop="units3" width="100"></el-table-column>
        <el-table-column label="6～7 m/s台数" prop="units4" width="120"></el-table-column>
        <el-table-column label="≥8 m/s台数" prop="units5" width="100"></el-table-column>
        <el-table-column label="是否在保" prop="inPaul"></el-table-column>
        <el-table-column label="签订公司" prop="signCompany" width="250"></el-table-column>
        <el-table-column label="跟单分公司" prop="followCompany" width="250"></el-table-column>
        <el-table-column label="安装地址" prop="installationAddress" width="250"></el-table-column>
        <el-table-column label="安装合同归属" prop="installationContractAttribution" width="120"></el-table-column>
        <el-table-column label="合同大客户简称" prop="contractLargeCustomerAbbreviation" width="150"></el-table-column>
        <el-table-column label="大客户编码" prop="keyAccountCode" width="150"></el-table-column>
        <el-table-column label="业务类型" prop="businessType" width="150"></el-table-column>
        <el-table-column label="商机编号" prop="businessNum" width="160"></el-table-column>
        <el-table-column label="项目子类型 (商机名称) (商机)" prop="projectSubname" width="120"></el-table-column>
        <el-table-column label="分公司签订人" prop="branchContractSignator" width="120"></el-table-column>
        <el-table-column label="分公司合同责任人" prop="branchContractResponsible" width="150"></el-table-column>
        <el-table-column label="总公司合同签订人" prop="parentContractSignator" width="120"></el-table-column>
        <el-table-column label="总公司合同负责人" prop="parentContractResponsible" width="120"></el-table-column>
        <el-table-column label="合同归属部门" prop="contractBelongsDepartment" width="120"></el-table-column>
        <el-table-column label="创建时间" width="150">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormatter }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="150">
          <template slot-scope="scope">
            <span v-for="item in scope.row.projectTypes" :key="item">
              <el-button v-show="item === '个人项目档案'" @click="goProject(scope.row.id,'个人项目档案')"  type="text">个人项目档案</el-button>
              <el-button v-show="item === '分公司项目档案'" :disabled="!scope.row.companyStatus" @click="goProject(scope.row.id,'分公司项目档案')"  type="text">分公司项目档案</el-button>
              <el-button v-show="item === '总部项目档案'" :disabled="!scope.row.status" @click="goProject(scope.row.id,'总部项目档案')" type="text">总部项目档案</el-button>
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="operation">
        <div class="pager">
          <el-pagination
            @size-change="sizeChangeHandleHis"
            @current-change="currentChangeHandleHis"
            :current-page="form.page"
            :page-sizes="[5, 10, 20, 50, 100]"
            :page-size="form.size"
            :total="total"
            background
            layout="total, sizes, prev, pager, next, jumper"
            style="text-align: right;padding-bottom: 20px;margin: 25px 50px">
          </el-pagination>
        </div>
      </div>
      <el-dialog
        :visible.sync = "dialog"
        style="width: 50%;margin:0 auto"
        :before-close="closeUp"
      >
        <el-form :model="fileForm" :rules="rule" ref="fileForm">
          <el-form-item label="导出选择文件" prop="fileName">
            <el-input placeholder="请输入文件名" v-model="fileForm.fileName" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
        <el-button @click="closeUp">取 消</el-button>
        <el-button type="primary" @click="goExport">确 定</el-button>
      </span>
      </el-dialog>
    </div>
  </div>
  <el-dialog
    :visible.sync = "dialogText"
    style="width: 50%;margin:0 auto"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item label="导出选择文件" prop="docName">
        <el-input placeholder="请输入文件名" v-model="form.docName" />
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <el-button @click="dialogText = false">取 消</el-button>
        <el-button type="primary" @click="goSelectExport">确 定</el-button>
      </span>
  </el-dialog>
  <!--    指引视频-->
  <div class="video_but" v-if="viodeShow">
    <img src="../../assets/btn_close@2x.png" class="btn" @click="viodeShow = false"/>
    <img src="../../assets/pic_videoguide@2x.png" style="width: 120px;height: 120px;padding-top: 20px" @click="videoPlay"/>
  </div>
  <!--    弹窗视频-->
  <el-dialog
    :visible.sync="dialogviode"
    width="40%"
    title="指引视频"
    :before-close="videoPlayClose">
    <div>
      <div class="videoDom">
        <div class="video">
          <video
            x5-playsinline="true"
            playsinline="true"
            webkit-playsinline="true"
            class="videodom"
            preload="auto"
            controls
            ref="videoNode"
            style="
                width: 100%;
              "
            :src="fileUrl"
          ></video>
        </div>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import {mapMutations} from "vuex";
import moment from "moment";
import exportExcel from '@/utils/exportExcel'
import { projectList } from '@/api/projectManage'
import {projectExport} from "../../api/projectManage";
export default {
  name: "performanceList",
  data(){
    return{
      selectValue: [
        {
          id: 1,
          value: null,
          name: '全部'
        },
        {
          id: 2,
          value: false,
          name: '无'
        },
        {
          id: 3,
          value: true,
          name: '有'
        }
      ],
      // 视频
      dialogviode: false,
      fileUrl: 'https://helc-cms-file.oss-cn-guangzhou.aliyuncs.com/video/%E5%B9%B3%E5%8F%B0%E4%BD%BF%E7%94%A8%E6%8C%87%E5%BC%95%E8%A7%86%E9%A2%91-%E3%80%90%E4%B8%9A%E7%BB%A9%E6%B8%85%E5%8D%95%E3%80%91%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4',
      viodeShow: true,
      form:{
        startTime:'',
        endTime:'',
        customerName:null,
        projectName:null,
        province: '', //省份
        city: '', //城市
        docName: null, // 文档名称
        page:1,
        size:10,
        busTypeId: null, // 业态类型
        busId: null,
        elevatorTId: null, // 梯种
        elevatorId: null, // 梯种系列
        contractNum: null, // 合同编号
        area: null,
        firstConsultationStartTime: '',
        firstConsultationEndTime: '',
        receiveCertificatesStartTime: '',
        receiveCertificatesEndTime: '',
        straightUnitsMin: null,
        straightUnitsMax: null,
        escalatorsUnitsMin: null,
        escalatorsUnitsMax: null,
        totalUnitsMin: null,
        totalUnitsMax: null,
        speedMin: null,
        speedMax: null,
        projectBidNotice: null,
        projectAcceptReport: null,
        projectContractScaner: null
      },
      straightRaisedHighMin: '',
      straightRaisedHighMax: '',
      escalatorsRaisedHighMin: '',
      escalatorsRaisedHighMax: '',
      contractTotalPriceMin: '',
      contractTotalPriceMax: '',
      deviceSignedPriceMin: '',
      deviceSignedPriceMax: '',
      projectSignedPriceMin: '',
      projectSignedPriceMax: '',
      total:0,
      provinceList: [],
      performanceList:[],
      check:false,
      num:0,
      ids:[],
      dialog:false,
      fileForm:{
        fileName:''
      },
      rule:{
        fileName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      },
      rules:{
        docName: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
      },
      businessTypeList: [],
      seriesList: [],
      elevatorSeriesList: [],
      optionsArea: [],
      dialogText: false,
      activeName:1,
      icon:'el-icon-arrow-down',
      showSelete: false,
      scroll: ''
    }
  },
  filters: {
    dateFormatter(val) {
      return moment(val).format('YYYY-MM-DD HH:mm')
    }
  },
  // 路由跳转之前保存当前滚动条的位置。
  beforeRouteLeave(to, from, next) {
    this.scroll = document.getElementsByClassName(
      "el-table__body-wrapper"
    )[0].scrollTop;
    next();
  },
//使用keepAlive缓存组件状态，页面切换路由会触发 activated 钩子函数。在 activated 中将 之前记录的位置赋值给引起滚动条滚动元素的 scrollTop
  activated(){
    console.log('abc')
    this.$nextTick(() => {
      setTimeout(() => {
// 也可以使用 document.getElementsByClassName("el-table__body-wrapper")[0].scrollTop = this.scroll
        this.$refs.table.bodyWrapper.scrollTop = this.scroll;
      }, 0);
    });
  },
  methods:{
    ...mapMutations(['changeMenuStatus']),
    // 关闭视频
    videoPlayClose() {
      this.$refs.videoNode.pause();
      this.dialogviode = false
      clearTimeout()
      this.fileUrl = ''
    },
    videoPlay() {
      this.dialogviode = true
      this.fileUrl = 'https://helc-cms-file.oss-cn-guangzhou.aliyuncs.com/video/%E5%B9%B3%E5%8F%B0%E4%BD%BF%E7%94%A8%E6%8C%87%E5%BC%95%E8%A7%86%E9%A2%91-%E3%80%90%E4%B8%9A%E7%BB%A9%E6%B8%85%E5%8D%95%E3%80%91%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B.mp4'
      setTimeout(()=> {
        this.$refs.videoNode.play()
      }, 1000)
    },
    onRadioChange(e) {
      // 当点击已经选中的把 radio 置空，就是取消选中，并返回
      if (this.form.projectBidNotice === e) {
        this.form.projectBidNotice = null
        return
      }
      // 不是选中，选中当前点击 Radio
      this.form.projectBidNotice = e
    },
    onRadioChange2(e) {
      // 当点击已经选中的把 radio 置空，就是取消选中，并返回
      if (this.form.projectContractScaner === e) {
        this.form.projectContractScaner = null
        return
      }
      // 不是选中，选中当前点击 Radio
      this.form.projectContractScaner = e
    },
    onRadioChange3(e) {
      // 当点击已经选中的把 radio 置空，就是取消选中，并返回
      if (this.form.projectAcceptReport === e) {
        this.form.projectAcceptReport = null
        return
      }
      // 不是选中，选中当前点击 Radio
      this.form.projectAcceptReport = e
    },
    conversion(num) {
      if (!num) {
        return
      }
      var str = num.toString()
      var index = str.indexOf('.')
      var count = 0
      if (index !== -1) {
        var a = str.charAt(index + 1)
        var b = str.charAt(index + 2)
        if (b !== 0) {
          count += 2
        } else if (a !== 0) {
          count++
        }
      }
      count += 4
      var res = (num / 10000)
      res = parseFloat(res.toFixed(count))
      return res
    },
    conversionM(num) {
      if (!num) {
        return
      }
      var str = num.toString()
      var index = str.indexOf('.')
      var count = 0
      if (index !== -1) {
        var a = str.charAt(index + 1)
        var b = str.charAt(index + 2)
        if (b !== 0) {
          count += 2
        } else if (a !== 0) {
          count++
        }
      }
      count += 4
      var res = (num / 100)
      res = parseFloat(res.toFixed(count))
      return res
    },
    getTimes() {
      if(this.form.startTime.length === 16){
        this.form.startTime = this.form.startTime+':00'
      }
      if(this.form.endTime.length === 16){
        this.form.endTime = this.form.endTime+':00'
      }
      if(this.form.firstConsultationStartTime.length != 0){
        this.form.firstConsultationStartTime = this.form.firstConsultationStartTime+' 00:00:00'
      }
      if(this.form.firstConsultationEndTime.length != 0){
        this.form.firstConsultationEndTime = this.form.firstConsultationEndTime+' 23:59:59'
      }
      if(this.form.receiveCertificatesStartTime.length != 0){
        this.form.receiveCertificatesStartTime = this.form.receiveCertificatesStartTime+' 00:00:00'
      }
      if(this.form.receiveCertificatesEndTime.length != 0){
        this.form.receiveCertificatesEndTime = this.form.receiveCertificatesEndTime+' 23:59:59'
      }
    },
    getListSelect() {
      this.form.page = 1
      this.getTimes()
      this.getList()
    },
    goShow(){
      if(this.showSelete){
        this.icon = 'el-icon-arrow-down'
        this.showSelete = false
      }else{
        this.icon = 'el-icon-arrow-up'
        this.showSelete = true
      }
    },
    selectDao(){
      this.dialogText = true
      this.form.docName = ''
    },
    goSelectExport(){
      this.$refs['form'].validate(valid=>{
        if(valid){
          this.getTimes()
          const ids = []
          const contractTotalPriceMin = this.contractTotalPriceMin ? (this.contractTotalPriceMin * 10000) : this.contractTotalPriceMin
          const contractTotalPriceMax = this.contractTotalPriceMax ? (this.contractTotalPriceMax * 10000) : this.contractTotalPriceMax
          const deviceSignedPriceMin = this.deviceSignedPriceMin ? (this.deviceSignedPriceMin * 10000) : this.deviceSignedPriceMin
          const deviceSignedPriceMax = this.deviceSignedPriceMax ? (this.deviceSignedPriceMax * 10000) : this.deviceSignedPriceMax
          const projectSignedPriceMin = this.projectSignedPriceMin ? (this.projectSignedPriceMin * 10000) : this.projectSignedPriceMin
          const projectSignedPriceMax = this.projectSignedPriceMax ? (this.projectSignedPriceMax * 10000) : this.projectSignedPriceMax
          const straightRaisedHighMin = this.straightRaisedHighMin
          const straightRaisedHighMax = this.straightRaisedHighMax
          const escalatorsRaisedHighMin = this.escalatorsRaisedHighMin
          const escalatorsRaisedHighMax = this.escalatorsRaisedHighMax
          this.form.size = 100000
          projectExport(this.form,contractTotalPriceMin, contractTotalPriceMax, deviceSignedPriceMin, deviceSignedPriceMax, projectSignedPriceMin, projectSignedPriceMax, straightRaisedHighMin, straightRaisedHighMax, escalatorsRaisedHighMin, escalatorsRaisedHighMax).then(res=>{
            var disposition = res.headers['content-disposition']
            console.log(res)
            var fileName = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))

            let blob1 = new Blob([res.data], { type: 'application/xlsx' }) // 假设文件为pdf

            let link = document.createElement('a')

            link.href = window.URL.createObjectURL(blob1)

            link.download = fileName

            link.click()

            link.remove()

            this.dialogText = false
            this.getList()
          })
        }
      })
    },
    getArea() {
      this.$request.getArea().then(res => {
        this.optionsArea = res.data
      })
    },
    getBusinessTypeList() {
      this.$request.getBusinessTypeList().then((res) => {
        if (res.code === 200) {
          if (res.data.length > 0) {
            // if (res.data[0].bid == null) {
            //   res.data[0].bid = 100000
            // }
            this.businessTypeList = res.data[0].btList
          }
        }
      })
    },
    endHe(value) {
      if (this.form.firstConsultationStartTime) {
        if (new Date(value).getTime() > new Date(this.form.firstConsultationStartTime).getTime() - 8.64e7) {
          this.form.firstConsultationEndTime = value
        } else {
          this.form.firstConsultationEndTime = ''
          this.$message.warning(`请输入的结束时间要大于开始时间`)
        }
      }
    },
    endPro(value) {
      if (this.form.receiveCertificatesStartTime) {
        if (new Date(value).getTime() > new Date(this.form.receiveCertificatesStartTime).getTime() - 8.64e7) {
          this.form.receiveCertificatesEndTime = value
        } else {
          this.form.receiveCertificatesEndTime = ''
          this.$message.warning(`请输入的结束时间要大于开始时间`)
        }
      }
    },
    etElevatorSeriesList() {
      this.$request.getElevatorSeriesList().then((res) => {
        if (res.code === 200) {
          this.seriesList = res.data
        }
      })
    },
    handChange(val) {
      const data = {
        etIds: [val]
      }
      if(!val){
        this.form.elevatorId = null
      }
      this.$request.getElevatorTypeList(data).then(res => {
        this.elevatorSeriesList = res.data
      })
    },
    handleBusinessTypeChange(bid) {
      if(!bid){
        this.form.busId = null
        return
      }
      const obj = this.businessTypeList.find((item) => item.bid === bid)
      this.form.businessTypeName = obj.name
      this.form.businessId = undefined
    },
    handleBusinessChange(id) {
      const obj = this.businessList.find((item) => item.id === id)
      this.form.businessName = obj.name
    },
    goProject(id, item){
      this.$request.projectId(id).then(res => {
        if(item=='个人项目档案'){
          this.$router.push(`/manage/projectDetails/${res.data}/1`)
        }else if(item=='总部项目档案'){
          this.$router.push(`/manage/pDetails/${id}/2`)
        }else if(item=='分公司项目档案'){
          this.$router.push(`/manage/projectDetails/${res.data}/3`)
        }
      })
      // this.$router.push(`/manage/projectDetails/${id}/1`)
    },
    getList(){
      const contractTotalPriceMin = this.contractTotalPriceMin ? (this.contractTotalPriceMin * 10000) : this.contractTotalPriceMin
      const contractTotalPriceMax = this.contractTotalPriceMax ? (this.contractTotalPriceMax * 10000) : this.contractTotalPriceMax
      const deviceSignedPriceMin = this.deviceSignedPriceMin ? (this.deviceSignedPriceMin * 10000) : this.deviceSignedPriceMin
      const deviceSignedPriceMax = this.deviceSignedPriceMax ? (this.deviceSignedPriceMax * 10000) : this.deviceSignedPriceMax
      const projectSignedPriceMin = this.projectSignedPriceMin ? (this.projectSignedPriceMin * 10000) : this.projectSignedPriceMin
      const projectSignedPriceMax = this.projectSignedPriceMax ? (this.projectSignedPriceMax * 10000) : this.projectSignedPriceMax
      const straightRaisedHighMin = this.straightRaisedHighMin
      const straightRaisedHighMax = this.straightRaisedHighMax
      const escalatorsRaisedHighMin = this.escalatorsRaisedHighMin
      const escalatorsRaisedHighMax = this.escalatorsRaisedHighMax
      projectList(this.form,contractTotalPriceMin, contractTotalPriceMax, deviceSignedPriceMin, deviceSignedPriceMax, projectSignedPriceMin, projectSignedPriceMax, straightRaisedHighMin, straightRaisedHighMax, escalatorsRaisedHighMin, escalatorsRaisedHighMax).then(res=>{
        res.data.records.forEach(item => {
          item.straightRaisedHighM = this.conversionM(item.straightRaisedHigh)
          item.escalatorsRaisedHighM = this.conversionM(item.escalatorsRaisedHigh)
        })
        this.performanceList = res.data.records
        this.total = res.data.total
      })
    },
    closeUp() {
      this.dialog = false
      this.$refs.fileForm.resetFields()
      this.getList()
    },
    handleProvinceChange(e) {
      this.form.city = undefined
    },
    getCityList() {
      this.$request.getCityList().then((res) => {
        if (res.code == 200) {
          this.provinceList = res.data
        }
      })
    },
    end(value) {
      if (this.form.startTime) {
        if (new Date(value).getTime() > new Date(this.form.startTime).getTime() - 8.64e7) {
          this.form.endTime = value
        } else {
          this.form.endTime = ''
          this.$message.warning(`请输入的结束时间要大于开始时间`)
        }
      }
    },
    handleSelectionChange(val){
      if(val.length){
        val.forEach(item=>{
          this.ids.push(item.id)
        })
        this.num = val.length
        this.check = true
      }else{
        this.ids = []
        this.num = 0
        this.check = false
      }
    },
    // 每页数
    sizeChangeHandleHis (val) {
      this.form.size = val
      this.form.page = 1
      this.getList()
    },
    // 当前页
    currentChangeHandleHis (val) {
      this.form.page = val
      this.getList()
    },
    clearForm(){
      this.form.page = 1
      this.form.startTime = ''
      this.form.endTime=''
      this.form.customerName=''
      this.form.projectName=''
      this.form.province= ''//省份
      this.form.city= '' //城市
      this.form.docName= '' // 文档名称
      this.form.busTypeId= null // 业态类型
      this.form.busId= null
      this.form.elevatorTId= null // 梯种
      this.form.elevatorId= null // 梯种系列
      this.form.contractNum= '' // 合同编号
      this.form.area= null
      this.form.firstConsultationStartTime= ''
      this.form.firstConsultationEndTime= ''
      this.form.receiveCertificatesStartTime= ''
      this.form.receiveCertificatesEndTime= ''
      this.form.straightUnitsMin= null
      this.form.straightUnitsMax= null
      this.form.escalatorsUnitsMin= null
      this.form.escalatorsUnitsMax= null
      this.form.totalUnitsMin= null
      this.form.totalUnitsMax= null
      this.contractTotalPriceMin= ''
      this.contractTotalPriceMax= ''
      this.deviceSignedPriceMin= ''
      this.deviceSignedPriceMax= ''
      this.projectSignedPriceMin= ''
      this.projectSignedPriceMax= ''
      this.straightRaisedHighMin= ''
      this.straightRaisedHighMax= ''
      this.escalatorsRaisedHighMin= ''
      this.escalatorsRaisedHighMax= ''
      this.form.speedMin= null
      this.form.speedMax= null
      this.form.projectBidNotice = null
      this.form.projectContractScaner = null
      this.form.projectAcceptReport = null
      this.getList()
    },
    //导出
    getExport(){
      if(this.check){
        this.dialog = true
      }else{
        this.$message.warning(`请选择要进行导出的文件`)
      }
    },
    goExport(){
      this.$refs['fileForm'].validate(valid=>{
        if(valid){
          this.$request.exportList(this.fileForm.fileName, this.unique(this.ids)).then(res=>{
            var disposition = res.headers['content-disposition']

            var fileName = decodeURI(disposition.substring(disposition.indexOf('filename=') + 9, disposition.length))

            let blob1 = new Blob([res.data], { type: 'application/xlsx' }) // 假设文件为pdf

            let link = document.createElement('a')

            link.href = window.URL.createObjectURL(blob1)

            link.download = fileName

            link.click()

            link.remove()

            this.dialog = false
            this.fileForm.fileName = ''
            this.ids = []
            this.closeUp()
          })
          this.$message.success(`导出成功`)
        }
      })
    },
    unique(arr) {
      var newArr = []
      for (var i = 0; i < arr.length; i++) {
        if (!newArr.includes(arr[i])) {
          newArr.push(arr[i])
        }
      }
      return newArr
    }
  },
  computed: {
    cityList() {
      let result = []
      if (this.form.province) {
        const cityObj = this.provinceList.find(
          (item) => item.province == this.form.province
        )
        if (cityObj) {
          result = cityObj.cities.map((item) => {
            return { value: item, lable: item }
          })
        }
      }
      return result
    },
    businessList() {
      let result = []
      const bObj = this.businessTypeList.find(
        (item) => item.bid === this.form.busTypeId
      )
      if (bObj) {
        result = bObj.btList
      }
      return result
    }
  },
  mounted() {
    console.log(1)
    this.changeMenuStatus({ value: 2 })
    this.getCityList()
    this.getList()
    this.etElevatorSeriesList()
    this.getBusinessTypeList()
    this.getArea()
  }
}
</script>

<style scoped lang="less">
// 视频
.videoDom {
  //width: 50%;
  position: relative;
}
// 视频
.video {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  position: relative;
  border-radius: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  // 遮罩层
  .video_overlay {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  // 播放
  .video_play {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  video {
    vertical-align: middle;
  }
}
.btn{
  height: 30px;
  width: 30px;
  position: fixed;
  right: 40px;
  margin-bottom: 50px;

}
.video_but{
  color: white;
  position: fixed;
  right: 50px;
  bottom: 100px;
  cursor: pointer;
}
::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  -webkit-box-shadow: 0 0 2px 2px #0000;
  box-shadow: 0 0 2px 2px #0000;
}
.rad{
  margin-right: 15px;
}
::v-deep.el-table .el-button+.el-button{
  margin-left: 0 !important;
}
::v-deep .el-table__empty-block{
  width: 1500px !important;
}
::v-deep .el-form-item {
  margin-bottom: 8px;
}
.JournalismShow{
  margin: 0 auto;
  cursor: pointer;
  line-height: 40px;
  color: #8c939d;
}
.performance{
  height: 100%;
  background-color: #F4F4F5;
  &>.main-con {
    padding-top: 16px;
    width: 15.04rem;
    margin: 0 auto;
    min-width: 1000px;
    &>.search{
      background-color: white;
      padding: 16px 24px;
      &>.search_form{
        display: flex;
        flex-wrap: wrap;
      }
    }
    &>.per_List{
      margin-top: 16px;
      background-color: white;
      padding:16px 20px;
      &>.text{
        display: flex;
        .title{
          font-size: 20px;
          font-family: OPPOSans-Medium, OPPOSans;
          font-weight: 500;
          color: rgba(0,0,0,0.85);
          line-height: 28px;
        }
      }
      &>.check{
        margin-top: 20px;
         display: flex;
         line-height: 30px;
         margin-left: 20px;
       }
      &>.el-table{
        margin-top: 16px;
      }
      &>.operation{
        display: flex;
        justify-content: space-between;
        line-height: 80px;
        margin-left: 24px;

      }
    }
  }
}
::v-deep .el-form-item{
  display: flex;
  margin-left: 16px;
}
::v-deep .el-input__inner{
  height: 32px !important;
}
.time_input{
  border:1px solid #dbdbde;
  padding: 0px;
  margin: 0px;
  margin-top:4px;
  border-radius:2px;
  ::v-deep .el-input__inner{
    border: none !important;
  }
}
.time_form{
  ::v-deep .el-form-item__content{
    line-height: 32px;
  }
  ::v-deep .el-input__icon{
    line-height: 32px;
  }
}
</style>
